import FileBlock from './base/file-block';
import BlobFile from '@intercom/embercom-composer/lib/blob-file';
import Em from 'ember';
export default FileBlock.extend({
  type: 'attachment',
  isAttachment: true,
  isInline: false,
  serialized: Em.computed('name', 'size', 'contentType', 'url', 'uploadId', function () {
    return {
      id: this.get('uploadId'),
      name: this.get('name'),
      size: this.get('size'),
      contentType: this.get('contentType'),
      url: this.get('url')
    };
  }),
  extractAttributesFromFile: Em.on('init', function () {
    let file = this.get('file');
    if (file) {
      this.setProperties({
        name: file.name,
        contentType: file.type,
        size: file.size
      });
    }
  }),
  preprocess() {
    return new Em.RSVP.Promise(function (resolve, reject) {
      this._super().then(function success() {
        let url = BlobFile.createUrl(this.get('file'));
        this.set('url', url);
        resolve();
      }.bind(this), reject);
    }.bind(this));
  },
  uploadSuccess(policy) {
    this._super(policy);
    this.set('contentType', policy.content_type);
  }
});